import { Languages } from '@hermes/settings'

const sortLanguages = (languages: Languages, language: string) =>
  languages.sort((a, b) => {
    const isDefaultA = a.isoCode === language
    const isDefaultB = b.isoCode === language

    if (isDefaultA !== isDefaultB) {
      return isDefaultA ? -1 : 1
    }

    const isEnglishA = a.isoCode === 'en'
    const isEnglishB = b.isoCode === 'en'

    if (isEnglishA !== isEnglishB) {
      return isEnglishA ? -1 : 1
    }

    return a.name.localeCompare(b.name)
  })

export default sortLanguages
